export default __webpack_public_path__ + "static/media/file-send.b767dfa8.svg";